
<template>
  <div class="pp">
    <van-uploader :after-read="afterRead" multiple>
      <van-icon name="plus"></van-icon>
    </van-uploader>
  </div>

  <!-- <van-uploader v-model="fileList" multiple/> -->

  <!-- <van-uploader v-model="fileList2" multiple :max-count="2"/> -->

  <!-- <van-uploader>
        <van-button type="primary" icon="photo">上传图片</van-button>
  </van-uploader>-->

  <!-- <van-uploader v-model="fileList3" :before-read="beforeRead"/> -->
</template>

<script>
export default {
  name: "testUpload",
  i18n: {
    "zh-CN": {
      upload: "上传图片",
      preview: "图片预览",
      maxCount: "限制上传数量",
      beforeRead: "上传前校验",
      uploadStyle: "自定义上传样式",
      invalidType: "请上传 jpg 格式图片"
    },
    "en-US": {
      upload: "Upload Image",
      preview: "Preview Image",
      maxCount: "Max Count",
      beforeRead: "Before Read",
      uploadStyle: "Upload Style",
      invalidType: "Please upload an image in jpg format"
    }
  },
  data() {
    return {
      fileList: [],
      fileList2: [],
      fileList3: []
    };
  },
  methods: {
    beforeRead(file) {
      if (file.type !== "image/jpeg") {
        this.$toast(this.$t("invalidType"));
        return false;
      }
      return true;
    },
    afterRead(file) {
    }
  }
};
</script>

<style scoped>
.demo-uploader {
  background-color: #fff;
}
.van-uploader {
  margin-left: 15px;
}
.pp {
    width: 100px;
    height: 100px;
}
</style>
